var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"visible":_vm.visible,"cancelDialog":_vm.cancelDialogs,"confirmDialog":_vm.importConfirm,"isdeling":_vm.isdeling}},[_c('priview-pdf',{attrs:{"pdfUrl":_vm.fileUrl}}),_vm._v(" 存储位置：增值税销项电子发票目录/"+_vm._s(_vm.year)+"年/"+_vm._s(_vm.month)+"月 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }